import { makeStyles, styled } from '@material-ui/core/styles'

const defineHeight = (isEmbedView, fullleaderboard) => {
  if (isEmbedView) return 'unset'
  return fullleaderboard ? 500 : 720
}

const defineMobileHeight = (isEmbedView, fullleaderboard) => {
  if (isEmbedView) return 'unset'
  return fullleaderboard ? 485 : 525
}

const defineMargin = (isEmbedView, fullleaderboard) => {
  if (isEmbedView) return '24px'
  return fullleaderboard ? '24px' : '72px'
}

export const Hero = styled('div')(({
  theme, image, fullleaderboard, embedview,
}) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  color: theme.palette.common.white,
  padding: 0,
  [theme.breakpoints.down('md')]: {
    height: defineMobileHeight(embedview, fullleaderboard),
    backgroundImage: embedview ? 'none' : `url(${image}?h=750&w=1920&fit=fill&fl=progressive&q=80)`,
  },
  [theme.breakpoints.up('md')]: {
    height: defineHeight(embedview, fullleaderboard),
    backgroundImage: embedview ? 'none' : `url(${image}?h=920&w=2800&fit=fill&fl=progressive&q=80)`,
  },
}))

export const Logo = styled('div')(({ theme, image, fullleaderboard }) => ({
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundImage: `url(${image}?h=360&w=360&fit=fill&fl=progressive&q=80)`,
  width: '180px',
  height: '180px',
  [theme.breakpoints.down('sm')]: {
    width: '140px',
    height: '140px',
    backgroundImage: `url(${image}?h=280&w=280&fit=fill&fl=progressive&q=80)`,
    margin: fullleaderboard ? '24px 0 24px 0' : '64px 0 24px 0',
  },
  margin: fullleaderboard ? '32px 0 32px 0' : '108px 0 42px 0',
}))

export const SummaryBox = styled('div')(({ theme, fullleaderboard, embedview }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '424px',
  height: '146px',
  justifyContent: 'center',
  '& div:first-child': {
    background: '#d11',
    borderRadius: '6px 0px 0px 6px',
  },
  marginBottom: defineMargin(embedview, fullleaderboard),
  '& h2,h5': {
    fontFamily: 'Nunito Sans',
  },
  [theme.breakpoints.down('sm')]: {
    width: '328px',
    height: '127px',
    marginBottom: embedview ? theme.spacing(2) : theme.spacing(3),
  },
}))

const useStyles = makeStyles(theme => ({
  country: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    background: '#048',
    borderRadius: '0px 6px 6px 0px',
    color: theme.palette.primary.contrastText,
    '& h2': {
      fontSize: '70px',
    },
    '& h5': {
      fontSize: '20px',
    },
    [theme.breakpoints.down('sm')]: {
      '& h2': {
        fontSize: '60px',
      },
      '& h5': {
        fontSize: '18px',
      },
    },
  },
  moreInfo: {
    borderRadius: theme.spacing(5),
    borderColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      color: theme.palette.primary.contrastText,
    },
    [theme.breakpoints.only('xs')]: {
      border: '1px solid rgba(255, 255, 255, 0.3)',
      padding: '10px 24px',
      marginBottom: theme.spacing(3),
    },
  },
  cta: {
    top: '-2px',
    '&:after, &:before': {
      width: 8,
    },
  },
  arrowDown: {
    marginLeft: theme.spacing(1),
    border: '1px solid rgba(255, 255, 255, 0.5)',
    padding: '6px 0px 6px 0px',
    borderRadius: '10px',
    height: '1.4em',
  },
  adWrapper: ({ fullLeaderboard }) => ({
    position: 'absolute',
    width: '100%',
    display: 'flex',
    top: fullLeaderboard ? 'unset' : '70px',
  }),
  statusWrapper: {
    marginTop: '80px',
    width: '100%',
    [theme.breakpoints.only('xs')]: {
      marginTop: '70px',
    },
  },
}))

export default useStyles
